import { TTRouteConfig } from "@tt-app/models";
import { ROUTES } from "@tt-app/constants";

const { TERRATALK_LIVE } = ROUTES;

export const terratalkLiveRoutes: TTRouteConfig[] = [
  {
    name: TERRATALK_LIVE.LOBBY.NAME,
    path: TERRATALK_LIVE.LOBBY.PATH,
    type: "page",
    accessLevel: "authenticated",
    component: () =>
      import(/*webpackChunkName: "tt-core" */ "@tt-app/views/terratalkLive/Lobby.vue")
  }
];
